import i18n from '../i18n'
import { CUSTOMER_ROLE_MAPPING } from '../config'

export function getProviderRoleKey(customerId: string): string {
  return CUSTOMER_ROLE_MAPPING[customerId] || CUSTOMER_ROLE_MAPPING.default
}

/**
 * Get the localized provider role name for a given customer
 * @param customerId - The customer ID to get the role for
 * @returns Localized provider role name (e.g., "user", "provider")
 */
export function getProviderRole(customerId: string): string {
  const roleKey = getProviderRoleKey(customerId)
  return i18n.t(`roles.${roleKey}`, { defaultValue: roleKey })
}

/**
 * Get a dynamic provider label (e.g., "Provider Id", "User Name")
 * @param customerId - The customer ID to get the label for
 * @param labelType - The type of label ('id', 'name', 'service', 'logs')
 * @param extraParams - Additional parameters for interpolation (e.g., { date: '2023-12-01' })
 * @returns Localized label with appropriate provider role
 */
export function getProviderLabel(
  customerId: string,
  labelType: string,
  extraParams?: Record<string, any>
): string {
  const providerRole = getProviderRole(customerId)
  return i18n.t(`provider.${labelType}`, { providerRole, ...extraParams })
}
